<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <h3>{{ data.text }}</h3>
  <p class="name">{{ data.name }}</p>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="yesOnClick()" cdkFocusInitial class="btn-primary">
    {{ data?.primaryButton?.text || 'Confirmar' }}
  </button>
</div>
